import { useLang } from '@/i18n';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import NavProduct from '../comps/NavProduct';
import TabBundles from '../comps/TabBundles';
import TabMedia from '../comps/TabMedia';
import TabRecycling from '../comps/TabRecycling';
import TabSpecs from '../comps/TabSpecs';
import TabSupport from '../comps/TabSupport';
import { useProductDispatch, useProductStore } from '../ProductProvider';
import { EfCardCartItemProps } from './comps/P/EFCardCartLists';
import styles from './index.module.scss';
import ProductContent from './ProductContent';

const theme = 'white';
const tabList = ['Product', 'Recycling', 'Specs', 'Support', 'Media'];
export default function Detail() {
    const { productTabActive, pageStatus } = useProductStore();
    const dispatch = useProductDispatch();
    const router = useRouter();
    const { t } = useLang('delta3series');
    const { locale = 'us', query } = router;
    const tabName: string = (query.tab as string) || '';
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es', 'ph', 'nl'].includes(locale);
    const [showNav, setShowNav] = useState(!IS_EU_SITES || pageStatus !== 'statusA');

    const items: EfCardCartItemProps[] = [
        {
            tag: t('P_card1_tag'),
            title: t('P_card1_title'),
            desc: `${t('P_card1_power')}\n${t('P_card1_desc')}`,
            productId: '8095182717089',
            variantId: '44498903629985',
            quantity: 1,
        },
        {
            tag: t('P_card2_tag'),
            title: t('P_card2_title'),
            desc: `${t('P_card2_power')}\n${t('P_card2_desc')}`,
            productId: '14619593933167',
            variantId: '51641953550703',
            quantity: 1,
        },
        {
            tag: t('P_card3_tag'),
            title: t('P_card3_title'),
            desc: `${t('P_card3_power')}\n${t('P_card3_desc')}`,
            productId: '14686218781039',
            variantId: '51812607394159',
            quantity: 1,
        },
    ];
    const items2: EfCardCartItemProps[] = [
        {
            title: t('N_card1_title'),
            desc: '',
            productId: '8095160795297',
            variantId: '44597213003937',
            quantity: 1,
        },
        {
            title: t('N_card2_title'),
            desc: '',
            productId: '8095101517985',
            variantId: '51641953354095',
            quantity: 1,
        },
        {
            title: t('N_card3_title'),
            desc: '',
            productId: '14684998762863',
            variantId: '51809553744239',
            quantity: 1,
        },
    ];

    const [cards, setCards] = useState(JSON.parse(JSON.stringify(items)));
    const [cards2, setCards2] = useState(JSON.parse(JSON.stringify(items2)));

    const getAsynItem = async (item: any) => {
        const { variantId, productId } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    item.link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                    if (res?.data?.handle) {
                        item.link_more = `https://${locale}.ecoflow.com/products/${res?.data?.handle}?variant=${variantId}`;
                    }
                    return resolve({ ...item, ...res?.data });
                } else {
                    console.error(res?.message);
                    return reject([]);
                }
            } catch (e) {
                console.error(e);
                return reject([]);
            }
        });
    };

    useEffect(() => {
        if (locale === 'jp') {
            const tempArr = JSON.parse(JSON.stringify(items));
            const tempArr2 = JSON.parse(JSON.stringify(items2));
            const promises = tempArr?.map((item: any) => getAsynItem(item));
            const promises2 = tempArr2?.map((item: any) => getAsynItem(item));
            Promise.all(promises)
                .then((res: any[]) => {
                    setCards(res);
                })
                .catch((e) => {
                    console.error(e);
                });
            Promise.all(promises2)
                .then((res2: any[]) => {
                    setCards2(res2);
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }, []);

    useEffect(() => {
        if (tabName && tabList.includes(tabName)) {
            dispatch({
                type: 'changeProductTabActive',
                payload: tabName,
            });
        }
    }, [tabName]);

    useEffect(() => {
        setShowNav(locale === 'jp' || pageStatus !== 'statusA' || locale === 'au');
    }, [pageStatus]);

    return (
        <div className={styles.detail}>
            {showNav && <NavProduct />}
            <div className={`product-item-tab${productTabActive === 'Product' ? ' product-item-tab-active' : ''}`}>
                <ProductContent bundles={[...cards]} cards2={[...cards2]} />
            </div>
            {productTabActive === 'Bundles' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabBundles />
                </div>
            )}
            {productTabActive === 'Recycling' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabRecycling />
                </div>
            )}
            {productTabActive === 'Support' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSupport theme={theme} />
                </div>
            )}
            {productTabActive === 'Specs' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSpecs theme={theme} />
                </div>
            )}
            {productTabActive === 'Media' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabMedia />
                </div>
            )}
        </div>
    );
}
